// 信号等级枚举
export enum SignalLevel {
  STRONG_SELL = "STRONG_SELL",
  SELL = "SELL",
  NEUTRAL = "NEUTRAL",
  BUY = "BUY",
  STRONG_BUY = "STRONG_BUY",
}

//  recommendation?: "STRONG_BUY" | "BUY" | "NEUTRAL" | "SELL" | "STRONG_SELL";
export const recommendationMap = {
  STRONG_BUY: "Strong Buy",
  BUY: "Buy",
  NEUTRAL: "Neutral",
  SELL: "Sell",
  STRONG_SELL: "Strong Sell",
};

export const FAQ_TYPE = {
  FAQ: "faq",
  MOVES_REASON: "moves_reason",
} as const;

export enum Sentiment {
  BULLISH = "Bullish",
  BEARISH = "Bearish",
  NEUTRAL = "Neutral",
}

export enum SmaSignal {
  SMA5_TO_SMA10 = "SMA5_TO_SMA10",
  SMA10_TO_SMA20 = "SMA10_TO_SMA20",
  SMA20_TO_SMA30 = "SMA20_TO_SMA30",
  SMA30_TO_SMA60 = "SMA30_TO_SMA60",
}

// 信号等级类型
export type SignalLevelType = SignalLevel;
